export const M2_READING = {   // <--- ¡Tiene que llamarse igual!
  id: "m2-reading",
  title: "Reading Practice",
  topic: "Short Stories & Context",
  iconType: "book", // Icono de libro para lectura
  grammarImage: "/m2-reading.jpg", // Puedes poner una imagen genérica de lectura
  grammarText: "Lee cada párrafo atentamente y selecciona la palabra que mejor completa la historia.",
  sets: [
    // --- TEXTO 1: ANNA (El que tú escribiste) ---
    {
      id: "read-anna",
      title: "Story 1: Anna's Life",
      questions: [
        { 
          type: "mc", 
          q: "Paragraph 1\n\nMy name is Anna and I am twenty-five years old. I live in a small city in Canada. I ___ with my parents in a comfortable house near the center. The city is quiet and friendly, and people are nice.", 
          options: ["live", "lives", "living"], 
          a: "live" 
        },
        { 
          type: "mc", 
          q: "Paragraph 2\n\nEvery weekday, I wake up at seven o’clock and get ready for work. I eat breakfast and drink coffee. Then I ___ the bus to go to my office. The trip is short and easy.", 
          options: ["take", "takes", "taking"], 
          a: "take" 
        },
        { 
          type: "mc", 
          q: "Paragraph 3\n\nI work in a small office with five people. My job is simple, but I like it. My boss ___ very kind and helps everyone at work. We talk and work together every day.", 
          options: ["are", "is", "am"], 
          a: "is" 
        },
        { 
          type: "mc", 
          q: "Paragraph 4\n\nAfter work, I go home and relax. I like to watch TV or listen to music. Sometimes I ___ dinner for my family and we eat together at night.", 
          options: ["cook", "cooks", "cooking"], 
          a: "cook" 
        },
        { 
          type: "mc", 
          q: "Paragraph 5\n\nOn weekends, I meet my friends. We go to the park or have coffee. We ___ happy when we spend time together and enjoy our free time.", 
          options: ["feel", "feels", "feeling"], 
          a: "feel" 
        }
      ]
    },

    // --- TEXTO 2: DAVID (Estudiante universitario) ---
    {
      id: "read-david",
      title: "Story 2: David's Routine",
      questions: [
        { 
          type: "mc", 
          q: "Paragraph 1\n\nHi, I'm David. I am a student at the university in Madrid. I study history because I love old stories. I ___ in a small apartment with my brother.", 
          options: ["live", "lives", "living"], 
          a: "live" 
        },
        { 
          type: "mc", 
          q: "Paragraph 2\n\nIn the morning, I usually walk to the university. It is not far from my home. I ___ my classes at 9:00 am. My teachers are very interesting and smart.", 
          options: ["start", "starts", "starting"], 
          a: "start" 
        },
        { 
          type: "mc", 
          q: "Paragraph 3\n\nAt 1:00 pm, I have a break for lunch. I usually ___ a sandwich and an apple in the cafeteria. I talk with my friends about our lessons and plans.", 
          options: ["eat", "eats", "eating"], 
          a: "eat" 
        },
        { 
          type: "mc", 
          q: "Paragraph 4\n\nIn the afternoon, I go to the library. It is very quiet there. I ___ my homework and read books for my exams. I stay there until 6:00 pm.", 
          options: ["do", "does", "doing"], 
          a: "do" 
        },
        { 
          type: "mc", 
          q: "Paragraph 5\n\nIn the evening, I am tired but happy. I go home and make dinner. My brother and I ___ games or watch a movie before we go to sleep.", 
          options: ["play", "plays", "playing"], 
          a: "play" 
        }
      ]
    },

    // --- TEXTO 3: THE BAKER (Tercera persona singular - He) ---
    {
      id: "read-tom",
      title: "Story 3: Tom the Baker",
      questions: [
        { 
          type: "mc", 
          q: "Paragraph 1\n\nThis is Tom. He is a baker and he has a shop on Main Street. He ___ wonderful bread and cakes. Everyone in the town knows him.", 
          options: ["makes", "make", "making"], 
          a: "makes" 
        },
        { 
          type: "mc", 
          q: "Paragraph 2\n\nTom gets up very early, at 4:00 am. The town is dark and quiet. He goes to his shop and ___ the ovens. It is hot work, but he loves it.", 
          options: ["turns on", "turn on", "turning on"], 
          a: "turns on" 
        },
        { 
          type: "mc", 
          q: "Paragraph 3\n\nAt 8:00 am, he opens the door. The fresh bread smells delicious. Many customers ___ to the shop to buy breakfast. Tom smiles and says hello.", 
          options: ["come", "comes", "coming"], 
          a: "come" 
        },
        { 
          type: "mc", 
          q: "Paragraph 4\n\nIn the afternoon, Tom cleans the shop. He washes the floor and the tables. He ___ the shop at 5:00 pm and goes home to rest.", 
          options: ["closes", "close", "closing"], 
          a: "closes" 
        },
        { 
          type: "mc", 
          q: "Paragraph 5\n\nTom has a dog named Rex. In the evening, he ___ Rex for a long walk in the park. It is his favorite time of the day.", 
          options: ["takes", "take", "taking"], 
          a: "takes" 
        }
      ]
    },

    // --- TEXTO 4: MARIA'S HOUSE (Descripción de casa y familia) ---
    {
      id: "read-maria",
      title: "Story 4: Maria's House",
      questions: [
        { 
          type: "mc", 
          q: "Paragraph 1\n\nMaria lives in a beautiful white house near the beach. She ___ married and has two children. Her house is big and has a lovely garden.", 
          options: ["is", "are", "am"], 
          a: "is" 
        },
        { 
          type: "mc", 
          q: "Paragraph 2\n\nThere are three bedrooms upstairs. Maria's room ___ a large window with a view of the sea. It is very bright and sunny in the morning.", 
          options: ["has", "have", "having"], 
          a: "has" 
        },
        { 
          type: "mc", 
          q: "Paragraph 3\n\nDownstairs, there is a big kitchen. Maria loves cooking. She ___ dinner for her family every night. They eat pasta, fish, and salads.", 
          options: ["cooks", "cook", "cooking"], 
          a: "cooks" 
        },
        { 
          type: "mc", 
          q: "Paragraph 4\n\nThe living room is comfortable. There ___ a blue sofa and a big TV. The family sits there to watch movies on Friday nights.", 
          options: ["is", "are", "be"], 
          a: "is" 
        },
        { 
          type: "mc", 
          q: "Paragraph 5\n\nMaria loves her home. On Sundays, she works in the garden. She ___ flowers and waters the plants. It is a happy house.", 
          options: ["plants", "plant", "planting"], 
          a: "plants" 
        }
      ]
    },

    // --- TEXTO 5: WEEKEND TRIP (Plural - We/They) ---
    {
      id: "read-trip",
      title: "Story 5: A Weekend Trip",
      questions: [
        { 
          type: "mc", 
          q: "Paragraph 1\n\nMy friends and I love nature. Every summer, we ___ to the mountains for a weekend. We pack our bags with food, water, and warm clothes.", 
          options: ["go", "goes", "going"], 
          a: "go" 
        },
        { 
          type: "mc", 
          q: "Paragraph 2\n\nWe drive for three hours. The trip is fun because we listen to music and sing. When we arrive, we ___ our tents near the river.", 
          options: ["set up", "sets up", "setting up"], 
          a: "set up" 
        },
        { 
          type: "mc", 
          q: "Paragraph 3\n\nIn the afternoon, we walk in the forest. We see birds and tall trees. The air ___ fresh and clean. We take many photos of the beautiful view.", 
          options: ["is", "are", "am"], 
          a: "is" 
        },
        { 
          type: "mc", 
          q: "Paragraph 4\n\nAt night, we make a fire. We sit around it and tell stories. It is cold, but the fire ___ us warm. We look at the stars in the sky.", 
          options: ["keeps", "keep", "keeping"], 
          a: "keeps" 
        },
        { 
          type: "mc", 
          q: "Paragraph 5\n\nOn Sunday, we swim in the river. The water is cold! We ___ tired but happy when we drive back home. We love our camping trips.", 
          options: ["are", "is", "am"], 
          a: "are" 
        }
      ]
    }
  ]
};
